import { isEqual } from 'lodash';
export function getAppSyncError(apolloError, path) {
    if (apolloError?.graphQLErrors) {
        const pathParts = path.split('.');
        return apolloError.graphQLErrors.find((error) => isEqual(error.path, pathParts));
    }
    return undefined;
}
